import { render, staticRenderFns } from "./Reportes.vue?vue&type=template&id=2b2eeaac&scoped=true"
import script from "./Reportes.vue?vue&type=script&lang=js"
export * from "./Reportes.vue?vue&type=script&lang=js"
import style0 from "./Reportes.vue?vue&type=style&index=0&id=2b2eeaac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2eeaac",
  null
  
)

export default component.exports